<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 px-4">Overzicht</h1>
    </div>

    <div v-if="userType == 'Administrator'" class="top-row  d-flex flex-row flex-grow mx-3 pb-3 justify-between">
      <div class="d-flex flex-row flex-grow">
        <div class="filterChauffeur" v-for="chauffeur in chauffeurs" :key="chauffeur.id">
          <div class="control-me"></div>
          <input v-model="showCalendarFor" type="checkbox" :value="chauffeur.id" :id="'chauffeur' + chauffeur.id" />
          <label :for="'chauffeur' + chauffeur.id">{{ chauffeur.naam }}</label>
        </div>
      </div>

      <button type="button" class="btn btn-secondary btn-cmr" @click="showCMR()">
        CMR
      </button>
    </div>

    <div class="d-flex flex-row">
      <div class="mx-3 d-flex flex-row flex-grow-1">
        <div v-if="userType == 'Administrator'" class="unplannedContainer">
          <div
            class="unplanned"
            v-for="(item, i) in unplanned"
            :key="i"
            draggable="true"
            @dragstart="onEventDragStart($event, item)"
          >
            <div :class="item.class + ' unplanned-item'">
              <strong>{{ item.title }}</strong>
              <div>{{ item.content }}</div>
            </div>
          </div>
        </div>
        <vue-cal
          :events="filteredEvents"
          :disable-views="['years', 'year', 'month']"
          :time-from="5 * 60"
          :time-to="19 * 60"
          :time-step="15"
          :snap-to-time="15"
          :hide-weekdays="[7]"
          :editable-events="{
            title: false,
            drag: userType == 'Administrator',
            resize: false,
            delete: false,
            create: false,
          }"
          locale="nl"
          :on-event-click="editEvent"
          @ready="loadEvents($event)"
          :on-drag-event="editEvent"
          @event-change="changedEvent($event)"
          @view-change="viewChange($event)"
          @event-drop="onEventDrop"
        >
        </vue-cal>
      </div>
    </div>

    <!-- <div id="agenda" class="container-fluid px-4">
      <div class="row week d-flex flex-row align-items-center">
        <h2 class="px-3">Week {{ currentWeek }}</h2>
        <div class="text-right">
          <b-icon class="mx-1" icon="chevron-left" @click="previousWeek()"></b-icon>
          <b-icon class="mx-1" icon="chevron-right" @click="nextWeek()"></b-icon>
        </div>
        <div class="d-flex flex-row flex-grow">
          <div class="filterChauffeur" v-for="chauffeur in chauffeurs" :key="chauffeur.id">
            <div class="control-me"></div>
            <input v-model="showCalendarFor" type="checkbox" :value="chauffeur.id" :id="'chauffeur' + chauffeur.id" />
            <label :for="'chauffeur' + chauffeur.id">{{ chauffeur.naam }}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" v-for="(day, dIndex) in agenda" :key="dIndex">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <h6 class="mb-0">
                {{ day.date | moment("dddd") }} -
                <span class="weekDayDate">{{ day.date | moment("D/M/YYYY") }}</span>
              </h6>
            </template>
            <b-card-text>
              <div v-for="(v, index) in day.vandaag" :key="index">
                <div @click="overzichtModal(v.id, v.type)" class="o-item" v-if="!v.hidden">
                  <template v-if="v.type === 'levering 2'">
                    <b-badge variant="primary">levering</b-badge>
                    <span class="date"> {{ v.richtuur | timeFormat }}</span>
                    <br />
                  </template>
                  <template v-if="v.type === 'levering'">
                    <b-badge variant="success">{{ v.type }}</b-badge>
                    <span class="date"> {{ v.leveringsrichtuur | timeFormat }}</span>
                    <br />
                  </template>
                  <template v-if="v.type === 'ophaling'">
                    <b-badge variant="warning">{{ v.type }}</b-badge>
                    <span class="date"> {{ v.ophalingsrichtuur | timeFormat }}</span>
                    <br />
                  </template>
                  <span v-if="v.type === 'levering 2'">{{ v.leveringsproduct_info.naam }}</span>
                  <span v-if="v.container_info">{{ v.afval_info.naam }} ({{ v.container_info.grootte }} m³)</span>
                  <br v-if="v.werf_info" />
                  <template v-if="v.gegevens_idem_klant == '0'">
                    <div v-if="v.werf_info">
                      <span
                        >{{ v.werf_info.straat }} {{ v.werf_info.huisnummer }} ,
                        {{ v.werf_info.postcode }}
                        {{ v.werf_info.gemeente }}</span
                      >
                    </div>
                  </template>
                  <template v-else>
                    <br />
                    <span
                      >{{ v.klant_info.straat }} {{ v.klant_info.huisnummer }} ,
                      {{ v.klant_info.postcode }}
                      {{ v.klant_info.gemeente }}</span
                    >
                  </template>

                  <div v-if="v.type === 'levering' && (v.vrachtwagen_info_levering || v.chauffeur_info_levering)">
                    <span v-if="v.chauffeur_info_levering" class="sub-info">{{ v.chauffeur_info_levering.naam }}</span>
                    <span v-if="v.vrachtwagen_info_levering || v.chauffeur_info_levering" class="sub-info">
                      -
                    </span>
                    <span v-if="v.vrachtwagen_info_levering" class="sub-info">{{
                      v.vrachtwagen_info_levering.beschrijving
                    }}</span>
                  </div>
                  <div v-if="v.type === 'levering 2' && (v.vrachtwagen_info || v.chauffeur_info)">
                    <span v-if="v.chauffeur_info" class="sub-info">{{ v.chauffeur_info.naam }}</span>
                    <span v-if="v.vrachtwagen_info || v.chauffeur_info" class="sub-info">
                      -
                    </span>
                    <span v-if="v.vrachtwagen_info" class="sub-info">{{ v.vrachtwagen_info.beschrijving }}</span>
                  </div>
                  <br v-if="v.type == 'ophaling' && (v.vrachtwagen_info_ophaling || v.chauffeur_info_ophaling)" />
                  <div v-if="v.type == 'ophaling' && (v.vrachtwagen_info_ophaling || v.chauffeur_info_ophaling)">
                    <span v-if="v.chauffeur_info_ophaling" class="sub-info">{{ v.chauffeur_info_ophaling.naam }}</span>
                    <span v-if="v.vrachtwagen_info_ophaling || v.chauffeur_info_ophaling" class="sub-info">
                      -
                    </span>
                    <span v-if="v.vrachtwagen_info_ophaling" class="sub-info">{{
                      v.vrachtwagen_info_ophaling.beschrijving
                    }}</span>
                  </div>
                  <div>
                    <p v-if="v.betalingsstatus == 'Betaald'" class="sub-info">
                      <span class="p"></span>
                      Betaald
                    </p>
                    <p v-else class="sub-info"><span class="np"></span> Niet betaald</p>
                  </div>
                </div>
                <hr v-if="index != Object.keys(vandaag).length - 1 && !v.hidden" />
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div> -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="overzichtModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Bestelling</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul v-if="modalType !== 'levering-product'" class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  class="nav-link active show"
                  href="#leveringTab"
                  aria-controls="leveringTab"
                  role="tab"
                  data-toggle="tab"
                  >Levering</a
                >
              </li>
              <li role="presentation">
                <a class="nav-link" href="#ophalingTab" aria-controls="ophalingTab" role="tab" data-toggle="tab"
                  >Ophaling</a
                >
              </li>
              <li role="presentation">
                <a class="nav-link" href="#fotosTab" aria-controls="fotosTab" role="tab" data-toggle="tab">Foto's</a>
              </li>
            </ul>

            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="leveringTab" v-if="bestelling">
                <label>Datum</label>
                <input
                  v-if="modalType !== 'levering-product'"
                  class="form-control"
                  v-model="bestelling.leveringsdatum"
                  type="text"
                />
                <input v-else class="form-control" v-model="bestelling.datum" type="text" />
                <label>Richtuur</label>
                <vue-timepicker
                  v-if="modalType !== 'levering-product'"
                  v-model="bestelling.leveringsrichtuur"
                  :minute-interval="15"
                ></vue-timepicker>
                <vue-timepicker v-else v-model="bestelling.richtuur" :minute-interval="15"></vue-timepicker>
                <hr />
                <label>Container</label>
                <select class="form-control" v-model="bestelling.container" disabled readonly>
                  <option
                    v-for="container in containers"
                    :key="container.id"
                    :value="container.id"
                    :disabled="!container.beschikbaar"
                    :selected="bestelling.container"
                  >
                    {{ container.beschrijving }}
                  </option>
                </select>
                <label>Vrachtwagen</label>
                <template v-if="modalType !== 'levering-product'">
                  <select
                    class="form-control"
                    v-model="bestelling.leveringsvrachtwagen"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="vrachtwagen in vrachtwagens"
                      :key="vrachtwagen.id"
                      :value="vrachtwagen.id"
                      :selected="bestelling.leveringsvrachtwagen"
                    >
                      {{ vrachtwagen.beschrijving }}
                    </option>
                  </select></template
                >
                <template v-else>
                  <select
                    class="form-control"
                    v-model="bestelling.vrachtwagen"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="vrachtwagen in vrachtwagens"
                      :key="vrachtwagen.id"
                      :value="vrachtwagen.id"
                      :selected="bestelling.vrachtwagen"
                    >
                      {{ vrachtwagen.beschrijving }}
                    </option>
                  </select>
                </template>
                <label>Chauffeur</label>
                <template v-if="modalType !== 'levering-product'">
                  <select
                    class="form-control"
                    v-model="bestelling.leveringschauffeur"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="chauffeur in chauffeurs"
                      :key="chauffeur.id"
                      :value="chauffeur.id"
                      :selected="bestelling.chauffeur"
                    >
                      {{ chauffeur.naam }}
                    </option>
                  </select>
                </template>
                <template v-if="modalType === 'levering-product'">
                  <select
                    class="form-control"
                    v-model="bestelling.chauffeur"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="chauffeur in chauffeurs"
                      :key="chauffeur.id"
                      :value="chauffeur.id"
                      :selected="bestelling.chauffeur"
                    >
                      {{ chauffeur.naam }}
                    </option>
                  </select>
                </template>
                <hr />
                <label>Klant</label>
                <select class="form-control" v-model="bestelling.klant" disabled readonly>
                  <option v-for="klant in klanten" :key="klant.id" :value="klant.id" :selected="bestelling.klant">
                    {{ klant.klantnaam }}
                  </option>
                </select>
                <label>Werf</label>
                <select class="form-control" v-model="bestelling.werf" disabled readonly>
                  <option v-for="werf in werven" :key="werf.id" :value="werf.id" :selected="bestelling.werf">
                    {{ werf.beschrijving }}
                  </option>
                </select>
                <template v-if="modalType !== 'levering-product'">
                  <label>Afvalproduct</label>
                  <select
                    class="form-control"
                    v-model="bestelling.afvalproduct"
                    :key="bestelling.id"
                    :selected="bestelling.afvalproduct"
                    disabled
                    readonly
                  >
                    <option value disabled>- Kies een afvalproduct -</option>
                    <option value="1">Gemengd afval</option>
                    <option value="2">Zuiver mengpuin</option>
                    <option value="3">Grond en stenen</option>
                    <option value="4">Bouw- en sloopafval</option>
                    <option value="5">Hout</option>
                    <option value="6">Groenafval</option>
                  </select></template
                >
                <template v-if="modalType === 'levering-product'">
                  <label>Product</label>
                  <select
                    class="form-control"
                    v-model="bestelling.leveringsproduct"
                    :key="bestelling.id"
                    :selected="bestelling.leveringsproduct"
                    disabled
                    readonly
                  >
                    <option v-for="product in leveringsproducten" :key="product.id" :value="product.id">{{
                      product.naam
                    }}</option>
                  </select>
                </template>
                <label>Notities</label>
                <textarea
                  class="form-control"
                  v-model="bestelling.notities_levering"
                  placeholder="Notities"
                  disabled
                  readonly
                ></textarea>
                <hr />
                <label>Geleverd?</label>
                <select class="form-control" v-model="bestelling.geleverd">
                  <option value="0">Nee</option>
                  <option value="1">Ja</option>
                </select>

                <template v-if="modalType === 'levering-product'">
                  <hr />
                  <label>Betalingswijze</label>
                  <select
                    class="form-control"
                    v-model="bestelling.betalingswijze"
                    :selected="bestelling.betalingswijze"
                    disabled
                    readonly
                  >
                    <option value="Factuur">Factuur</option>
                    <option value="Contant">Contant</option>
                    <option value="Bancontact">Bancontact</option>
                  </select>
                  <label>Betalingsstatus</label>
                  <select class="form-control" v-model="bestelling.betalingsstatus">
                    <option value="Niet betaald">Niet betaald</option>
                    <option value="Betaald">Betaald</option>
                  </select>
                </template>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'plaatsing')"
                >
                  Print vrachtbon
                </button>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2 mr-2"
                  v-on:click="signVrachtbon('levering')"
                >
                  Vrachtbon tekenen
                </button>
              </div>

              <div role="tabpanel" class="tab-pane" id="ophalingTab" v-if="bestelling">
                <label>Datum</label>
                <input class="form-control" v-model="bestelling.ophalingsdatum" type="text" />
                <label>Richtuur</label>
                <vue-timepicker v-model="bestelling.ophalingsrichtuur" :minute-interval="15"></vue-timepicker>
                <hr />
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingsvrachtwagen"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="bestelling.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }}
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingschauffeur"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="bestelling.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                <hr />
                <label>Gewicht (kg)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.gewicht"
                  placeholder="Gewicht"
                  readonly
                  disabled
                />
                <label>Prijs (€)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.prijs"
                  placeholder="Prijs"
                  disabled
                  readonly
                />
                <label>Betalingswijze</label>
                <select
                  class="form-control"
                  v-model="bestelling.betalingswijze"
                  :selected="bestelling.betalingswijze"
                  disabled
                  readonly
                >
                  <option value="Factuur">Factuur</option>
                  <option value="Contant">Contant</option>
                  <option value="Bancontact">Bancontact</option>
                </select>
                <label>Betalingsstatus</label>
                <select class="form-control" v-model="bestelling.betalingsstatus">
                  <option value="Niet betaald">Niet betaald</option>
                  <option value="Betaald">Betaald</option>
                </select>
                <label>Opmerking</label>
                <select class="form-control" v-model="bestelling.opmerkingen">
                  <option value disabled>- Selecteer opmerking -</option>
                  <option value="Niemand aanwezig">Niemand aanwezig</option>
                  <option value="Niemand aanwezig voor betaling">
                    Niemand aanwezig voor betaling
                  </option>
                  <option value="Container boven rand geladen">
                    Container boven rand geladen
                  </option>
                  <option value="Container overladen (gewicht)">
                    Container overladen (gewicht)
                  </option>
                  <option value="Wachttijd overschreden (15min.)">
                    Wachttijd overschreden (15min.)
                  </option>
                  <option value="Container onmogelijk bereikbaar">
                    Container onmogelijk bereikbaar
                  </option>
                </select>
                <label>Notities</label>

                <textarea class="form-control" v-model="bestelling.notities" placeholder="Notities"></textarea>
                <hr />
                <label>Opgehaald?</label>
                <select class="form-control" v-model="bestelling.opgehaald">
                  <option value="0">Nee</option>
                  <option value="1">Ja</option>
                </select>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'ophaling')"
                >
                  Print vrachtbon
                </button>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2 mr-2"
                  v-on:click="signVrachtbon('ophaling')"
                >
                  Vrachtbon tekenen
                </button>
              </div>
              <div role="tabpanel" class="tab-pane" id="fotosTab" v-if="bestelling">
                <div class="upload-container">
                  <vue-upload-multiple-image
                    v-if="showImageUpload"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    :data-images="bestelling.fotos"
                  ></vue-upload-multiple-image>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-on:click="updateBestelling()">
              Aanpassen
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Sluiten
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="signModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Tekenen</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="signatureContainer">
              <VPerfectSignature style="position: relative" :stroke-options="strokeOptions" ref="signaturePad" />
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="clear()">
              Opnieuw
            </button>
            <button type="button" class="btn btn-primary" v-on:click="saveSignature()">
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="cmrModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">CMR</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <label>Chauffeur</label>
            <select
              class="form-control"
              v-model="cmr.chauffeur"
              :disabled="utype !== 'Administrator'"
              :readonly="utype !== 'Administrator'"
            >
              <option
                v-for="chauffeur in chauffeurs"
                :key="chauffeur.id"
                :value="chauffeur.id"
                :selected="cmr.chauffeur"
              >
                {{ chauffeur.naam }}
              </option>
            </select>
            <label>Datum</label>
            <date-picker
              v-model="cmr.datum"
              placeholder="Kies datum"
              :value-type="'YYYY-MM-DD'"
              :editable="false"
              :format="'YYYY-MM-DD'"
            ></date-picker>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-on:click="generateCMR()">
              Tonen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import axios from "axios";

import "vue-search-select/dist/VueSearchSelect.css";

import moment from "moment";
import "moment/locale/nl-be";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/nl-be";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VPerfectSignature from "v-perfect-signature";

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import "vue-cal/dist/drag-and-drop.js";
import "vue-cal/dist/i18n/nl.js";

import VModal from "vue-js-modal";
Vue.use(VModal, { componentName: "modal" });

moment.updateLocale("nl-be", {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  name: "app",
  components: {
    DatePicker,
    VueTimepicker,
    VueUploadMultipleImage,
    VPerfectSignature,
    VueCal,
  },
  filters: {
    timeFormat(value) {
      const parts = value.split(":");
      return parts[0] + ":" + parts[1];
    },
  },
  data() {
    return {
      showImageUpload: false,
      utype: "Administrator",
      events: [],
      filteredEvents: [],
      vandaagArr: [],
      editModalTitle: "",
      showCalendarFor: [],
      showSignaturePad: false,
      afspraken: {},
      bestelling: {},
      vandaag: [],
      morgen: [],
      week: [],
      weekTitle: "",
      currentWeek: null,
      userType: null,
      containers: {},
      vrachtwagens: {},
      chauffeurs: {},
      klanten: [],
      werven: {},
      cmr: {
        chauffeur: undefined,
        datum: undefined,
      },
      ophalingen: [],
      leveringen: [],
      leveringsproducten: [],
      attrs: [
        {
          key: "today",
          highlight: "red",
          dates: [],
        },
      ],
      modalType: "",
      agenda: [],
      strokeOptions: {
        size: 4,
        thinning: 0,
        smoothing: 0.5,
        streamline: 0.5,
      },
      unplanned: [],
      handtekeningType: null,
    };
  },
  mounted() {
    const loggedIn = JSON.parse(localStorage.getItem("user"));
    this.userType = loggedIn.type;

    //this.getAfspraken();
    this.getWerven();
    this.getVrachtwagens();
    this.getChauffeurs();
    this.getContainers();
    this.getLeveringsproducten();
    this.getKlanten();
  },
  watch: {
    filteredEvents() {
      console.log("filteredEvents", this.filteredEvents);
    },
    events() {
      console.log("changed!", this.events);
      this.unplanned = this.events
        .filter(
          (x) =>
            (x.class === "levering" && x.leveringschauffeur == 0) ||
            (x.class === "ophaling" && x.ophalingschauffeur == 0) ||
            (x.class === "levering-product" && x.chauffeur == 0)
        )
        .map((x) => ({ ...x, duration: 30 }));

      console.log(this.unplanned);

      this.filteredEvents = this.events.filter((x) => {
        if (x.class === "levering") {
          return x.leveringschauffeur != 0;
        } else if (x.class === "ophaling") {
          return x.ophalingschauffeur != 0;
        } else {
          return x.chauffeur != 0;
        }
      });
    },
    showSignaturePad(val) {
      if (val) {
        setTimeout(() => {
          if (this.handtekeningType == "levering") {
            this.$refs.signaturePad.fromDataURL(this.bestelling.handtekening_levering);
          } else if (this.handtekeningType == "ophaling") {
            this.$refs.signaturePad.fromDataURL(this.bestelling.handtekening_ophaling);
          }

          this.$refs.signaturePad.resizeCanvas(true);
        }, 300);
      }
    },
    showCalendarFor() {
      console.log(this.events);
      console.log(this.showCalendarFor);

      if (this.showCalendarFor.length) {
        this.filteredEvents = this.events.filter((x) =>
          this.showCalendarFor.length
            ? (x.class === "levering" && this.showCalendarFor.includes(x.leveringschauffeur)) ||
              (x.class === "ophaling" && this.showCalendarFor.includes(x.ophalingschauffeur)) ||
              (x.class === "levering-product" && this.showCalendarFor.includes(x.chauffeur))
            : false
        );
      } else {
        this.filteredEvents = this.events;
      }

      /*  this.agenda = this.agenda.map((v) => {
        return {
          ...v,
          vandaag: v.vandaag.map((x) =>
            this.showCalendarFor.length
              ? x.type === "levering"
                ? this.showCalendarFor.includes(x.leveringschauffeur)
                  ? { ...x, hidden: false }
                  : { ...x, hidden: true }
                : x.type === "ophaling"
                ? this.showCalendarFor.includes(x.ophalingschauffeur)
                  ? { ...x, hidden: false }
                  : { ...x, hidden: true }
                : this.showCalendarFor.includes(x.chauffeur)
                ? { ...x, hidden: false }
                : { ...x, hidden: true }
              : { ...x, hidden: false }
          ),
        };
      }); */
    },
  },
  methods: {
    generateCMR() {
      window.open("https://hofman.weblion.be/api/cmr.php?c=" + this.cmr.chauffeur + "&d=" + this.cmr.datum, "_blank");
      $("#cmrModal").modal("hide");
    },
    showCMR() {
      $("#cmrModal").modal("show");
    },
    onEventDragStart(e, draggable) {
      // Passing the event's data to Vue Cal through the DataTransfer object.
      e.dataTransfer.setData("event", JSON.stringify(draggable));
      e.dataTransfer.setData("cursor-grab-at", e.offsetY);
    },
    onEventDrop({ event, originalEvent, external }) {
      // If the event is external, delete it from the data source on drop into Vue Cal.
      // If the event comes from another Vue Cal instance, it will be deleted automatically in there.
      console.log("ondrop", event);
      if (external) {
        const extEventToDeletePos = this.unplanned.findIndex((item) => item.id === originalEvent.id);
        if (extEventToDeletePos > -1) this.unplanned.splice(extEventToDeletePos, 1);
      }
    },
    changedEvent(event) {
      console.log("change", event);
      const ce = event.event;
      const time = moment(ce.start).format("HH:mm");
      const date = moment(ce.start).format("YYYY-MM-DD");
      if (ce.class == "levering") {
        axios.put("https://hofman.weblion.be/api/bestellingen/", {
          bestelling: {
            leveringsrichtuur: time,
            leveringsdatum: date,
            id: ce.id,
          },
        });
      } else if (ce.class == "ophaling") {
        axios.put("https://hofman.weblion.be/api/bestellingen/", {
          bestelling: {
            ophalingsrichtuur: time,
            ophalingsdatum: date,
            id: ce.id,
          },
        });
      } else {
        axios.put("https://hofman.weblion.be/api/leveringen/", {
          levering: {
            richtuur: time,
            datum: date,
            id: ce.id,
          },
        });
      }
      //this.bestelling = event.event;
      //this.updateBestelling();
    },
    viewChange(cal) {
      this.loadEvents(cal);
    },
    async loadEvents(cal) {
      const start = cal.startDate;
      const end = cal.endDate;
      const params = {
        start: start,
        end: end,
      };

      const bestellingen = await axios.get("https://hofman.weblion.be/api/bestellingen/", {
        params,
      });

      const leveringen = await axios.get("https://hofman.weblion.be/api/leveringen/", {
        params,
      });

      console.log(bestellingen);
      console.log(leveringen);

      const events = [...leveringen.data, ...bestellingen.data];

      this.events = events.map((x) => (x.datum ? this.transformLevering(x) : this.transformBestelling(x, start, end)));

      /* this.filteredEvents = events.map((x) =>
        x.datum ? this.transformLevering(x) : this.transformBestelling(x, start, end)
      ); */
    },
    transformBestelling(x, start, end) {
      console.log(x);
      const type = moment(x.leveringsdatum).isBetween(start, end) ? "levering" : "ophaling";
      const datum = type === "levering" ? x.leveringsdatum : x.ophalingsdatum;
      const uur = type === "levering" ? x.leveringsrichtuur : x.ophalingsrichtuur;
      return {
        ...x,
        title: x.afval_info.naam + " (" + x.container_info.grootte + "m³)",
        content: x.werf_info
          ? `${x.werf_info?.straat} ${x.werf_info?.huisnummer}, ${x.werf_info?.postcode} ${x.werf_info?.gemeente}`
          : "Geen adres",
        start: `${datum} ${uur}`,
        class: type,
        end: moment(`${datum} ${uur}`)
          .add(30, "minutes")
          .format("YYYY-MM-DD HH:mm:ss"),
      };
    },
    transformLevering(x) {
      return {
        ...x,
        title: x.leveringsproduct_info.naam,
        content: x.werf_info
          ? `${x.werf_info?.straat} ${x.werf_info?.huisnummer}, ${x.werf_info?.postcode} ${x.werf_info?.gemeente}`
          : "Geen adres",
        start: `${x.datum} ${x.richtuur}`,
        class: "levering-product",
        end: moment(`${x.datum} ${x.richtuur}`)
          .add(30, "minutes")
          .format("YYYY-MM-DD HH:mm:ss"),
      };
    },
    editEvent(event, e) {
      console.log({ event });

      this.bestelling = event;

      $("#overzichtModal").modal("show");

      e.stopPropagation();
    },
    clear() {
      this.$refs.signaturePad.clear();
    },

    saveSignature() {
      const dataURL = this.$refs.signaturePad.toDataURL();

      if (this.handtekeningType == "ophaling") {
        this.bestelling.opgehaald = true;
      } else {
        this.bestelling.geleverd = true;
      }

      this.updateBestelling();

      axios
        .put("https://hofman.weblion.be/api/handtekening/", {
          bestelling: this.bestelling,
          handtekening: dataURL,
          type: this.handtekeningType,
        })
        .then((response) => {
          console.log(response.data);
          $("#overzichtModal").modal("show");
          $("#signModal").modal("hide");
        });
    },
    signVrachtbon(type) {
      this.handtekeningType = type;
      $("#overzichtModal").modal("hide");
      $("#signModal").modal("show");
      this.showSignaturePad = true;
    },
    printVrachtbon(id, type) {
      this.modalType === "levering 2"
        ? window.open("https://hofman.weblion.be/api/levering.php?l=" + id, "_blank")
        : window.open("https://hofman.weblion.be/api/pdftest.php?b=" + id + "&type=" + type, "_blank");
    },
    uploadImageSuccess() {
      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    beforeRemove(index, done) {
      done();

      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    overzichtModal(index, type) {
      this.modalType = type;
      console.log(this.modalType);

      if (type === "levering 2") {
        axios
          .get("https://hofman.weblion.be/api/leveringen/", {
            params: {
              id: index,
            },
          })
          .then((res) => {
            this.bestelling = res.data[0];
            if (this.bestelling.betalingsstatus == "") {
              this.bestelling.betalingsstatus = "Niet betaald";
            }

            axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
              this.klanten = [res.data][0];

              $("#overzichtModal").modal("show");
            });
          });
      } else {
        axios
          .get("https://hofman.weblion.be/api/bestellingen/", {
            params: {
              id: index,
            },
          })
          .then((res) => {
            console.log(res.data[0]);
            this.bestelling = res.data[0];
            if (this.bestelling.betalingsstatus == "") {
              this.bestelling.betalingsstatus = "Niet betaald";
            }

            axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
              this.klanten = [res.data][0];
              console.log(this.klanten[0]);

              $("#overzichtModal").modal("show");
            });
          });
      }
    },
    /* weekAgenda(week) {
      this.agenda = [];
      let currentWeek = moment().week();

      for (var d = 1; d < 7; d++) {
        this.vandaagArr = [];
        let compare = moment().day(d + (week - currentWeek) * 7);

        for (var i = 0; i < this.afspraken.length; i++) {
          let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
          let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
          let afspraak = _.cloneDeep(this.afspraken[i]);

          //ophalen
          if (ophalingsdatum.isSame(compare, "day")) {
            let afspraak1 = _.cloneDeep(afspraak);
            afspraak1.type = "ophaling";
            afspraak1.tijdstip = moment(afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur);
            this.vandaagArr.push(afspraak1);
          }

          //leveren
          if (leveringsdatum.isSame(compare, "day")) {
            let afspraak1 = _.cloneDeep(afspraak);
            afspraak1.type = "levering";
            afspraak1.tijdstip = moment(afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur);
            this.vandaagArr.push(afspraak1);
          }
        }

        for (i = 0; i < this.leveringen.length; i++) {
          let datum = moment(this.leveringen[i]["datum"]);
          let levering = _.cloneDeep(this.leveringen[i]);

          //leveringen
          if (datum.isSame(compare, "day")) {
            let levering1 = _.cloneDeep(levering);
            levering1.type = "levering 2";
            levering1.tijdstip = moment(levering1.datum + " " + levering1.richtuur);
            this.vandaagArr.push(levering1);
          }
        }

        this.vandaagArr.sort(function(a, b) {
          return a.tijdstip - b.tijdstip;
        });

        let dag = compare;

        this.agenda.push({ date: dag, vandaag: this.vandaagArr });
      }

      this.agenda = this.agenda.map((v) => {
        return {
          ...v,
          vandaag: v.vandaag.map((x) =>
            this.showCalendarFor.length
              ? x.type === "levering"
                ? this.showCalendarFor.includes(x.leveringschauffeur)
                  ? { ...x, hidden: false }
                  : { ...x, hidden: true }
                : x.type === "ophaling"
                ? this.showCalendarFor.includes(x.ophalingschauffeur)
                  ? { ...x, hidden: false }
                  : { ...x, hidden: true }
                : this.showCalendarFor.includes(x.chauffeur)
                ? { ...x, hidden: false }
                : { ...x, hidden: true }
              : { ...x, hidden: false }
          ),
        };
      });
    }, */
    getLeveringsproducten() {
      axios.get("https://hofman.weblion.be/api/leveringsproducten/").then((res) => {
        this.leveringsproducten = res.data;
      });
    },
    /*
    getAfspraken() {
      axios
        .get("https://hofman.weblion.be/api/bestellingen/")
        .then((response) => {
          console.log(response.data);

          this.weekTitle = "week " + moment().week();
          this.currentWeek = moment().week();

          this.afspraken = response.data;

          let vandaagArr = [];
          let morgenArr = [];
          let weekArr = [];

          for (var i = 0; i < this.afspraken.length; i++) {
            let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
            let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
            let afspraak = _.cloneDeep(this.afspraken[i]);

            //vandaag
            if (ophalingsdatum.isSame(moment(), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "ophaling";
              afspraak1.tijdstip = moment(
                afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
              );
              vandaagArr.push(afspraak1);
            }

            //vandaag
            if (leveringsdatum.isSame(moment(), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "levering";
              afspraak1.tijdstip = moment(
                afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
              );
              vandaagArr.push(afspraak1);
            }

            //morgen
            if (ophalingsdatum.isSame(moment().add(1, "days"), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "ophaling";
              afspraak1.tijdstip = moment(
                afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
              );
              morgenArr.push(afspraak1);
            }

            //morgen
            if (leveringsdatum.isSame(moment().add(1, "days"), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "levering";
              afspraak1.tijdstip = moment(
                afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
              );
              morgenArr.push(afspraak1);
            }

            //week

            if (
              moment(ophalingsdatum).isBetween(
                moment().startOf("week"),
                moment().endOf("week")
              )
            ) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "ophaling";
              afspraak1.tijdstip = moment(
                afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
              );
              weekArr.push(afspraak1);
            }

            if (
              moment(leveringsdatum).isBetween(
                moment().startOf("week"),
                moment().endOf("week")
              )
            ) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "levering";
              afspraak1.tijdstip = moment(
                afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
              );
              weekArr.push(afspraak1);
            }
          }

          this.vandaag = vandaagArr;
          this.morgen = morgenArr;
          this.week = weekArr;

          this.vandaag.sort(function(a, b) {
            return a.tijdstip - b.tijdstip;
          });

          this.morgen.sort(function(a, b) {
            return a.tijdstip - b.tijdstip;
          });

          this.week.sort(function(a, b) {
            return a.tijdstip - b.tijdstip;
          });
        })
        .catch((error) => console.log(error));
    },
    */
    /* getAfspraken() {
      axios.get("https://hofman.weblion.be/api/bestellingen/").then((response) => {
        this.afspraken = response.data;

        axios.get("https://hofman.weblion.be/api/leveringen/").then((response) => {
          this.leveringen = response.data;

          this.weekTitle = "week " + moment().week();
          this.currentWeek = moment().week();
          this.weekAgenda(this.currentWeek);
        });
      });
    }, */
    /*
    previousWeek() {
      this.currentWeek = this.currentWeek - 1;
      this.weekTitle = "week " + this.currentWeek;
      let weekArr = [];
      for (var i = 0; i < this.afspraken.length; i++) {
        let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
        let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
        let afspraak = _.cloneDeep(this.afspraken[i]);
        //week

        if (
          moment(ophalingsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "ophaling";
          afspraak1.tijdstip = moment(
            afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
          );
          weekArr.push(afspraak1);
        }

        if (
          moment(leveringsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "levering";
          afspraak1.tijdstip = moment(
            afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
          );
          weekArr.push(afspraak1);
        }
      }

      this.week = weekArr;

      this.week.sort(function(a, b) {
        return a.tijdstip - b.tijdstip;
      });
    },
    */
    previousWeek() {
      this.currentWeek = this.currentWeek - 1;
      this.weekAgenda(this.currentWeek);
    },
    nextWeek() {
      this.currentWeek = this.currentWeek + 1;
      this.weekAgenda(this.currentWeek);
    },
    /*
    nextWeek() {
      this.currentWeek = this.currentWeek + 1;
      this.weekTitle = "week " + this.currentWeek;
      let weekArr = [];
      for (var i = 0; i < this.afspraken.length; i++) {
        let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
        let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
        let afspraak = _.cloneDeep(this.afspraken[i]);
        //week

        if (
          moment(ophalingsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "ophaling";
          afspraak1.tijdstip = moment(
            afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
          );
          weekArr.push(afspraak1);
        }

        if (
          moment(leveringsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "levering";
          afspraak1.tijdstip = moment(
            afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
          );
          weekArr.push(afspraak1);
        }
      }

      this.week = weekArr;

      this.week.sort(function(a, b) {
        return a.tijdstip - b.tijdstip;
      });
    },
    */
    getContainers() {
      axios.get("https://hofman.weblion.be/api/containers/").then((response) => {
        this.containers = response.data;
      });
    },
    getVrachtwagens() {
      axios.get("https://hofman.weblion.be/api/vrachtwagens/").then((response) => {
        this.vrachtwagens = response.data;
      });
    },
    getChauffeurs() {
      axios.get("https://hofman.weblion.be/api/chauffeurs/").then((response) => {
        this.chauffeurs = response.data;
      });
    },
    getWerven() {
      axios.get("https://hofman.weblion.be/api/werven/").then((response) => {
        this.werven = response.data;
      });
    },
    getKlanten() {
      axios.get("https://hofman.weblion.be/api/klanten/").then((response) => {
        this.klanten = response.data;
      });
    },

    updateBestelling() {
      if (this.modalType === "levering 2") {
        axios
          .put("https://hofman.weblion.be/api/leveringen/", {
            levering: this.bestelling,
          })
          .then((response) => {
            this.getAfspraken();
            if (response.status == "200") {
              $("#overzichtModal").modal("hide");
            }
            console.log(response);
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        axios
          .put("https://hofman.weblion.be/api/bestellingen/", {
            bestelling: this.bestelling,
          })
          .then((response) => {
            this.getAfspraken();
            if (response.status == "200") {
              $("#overzichtModal").modal("hide");
            }
            console.log(response);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}

.weekDayDate {
  font-size: 13px;
}

button {
  margin-right: 10px;
}

.date {
  margin-left: 6px;
  color: #999;
}

.sub-info {
  color: #999;
}

.table thead th {
  text-align: left !important;
}

.pager ul {
  list-style-type: none;
}

.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}

.modal input,
.modal select {
  margin-bottom: 5px;
}

.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

.dropdown {
  display: inline-block;
}

.dropdown-item:hover {
  cursor: pointer !important;
}

.dropdown-item i {
  margin-right: 3px;
}

/*
.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}
*/

.top-row {
  justify-content: space-between;
}

.o-item:hover {
  cursor: pointer;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}

.vue__time-picker input.display-time.disabled,
.vue__time-picker input.display-time:disabled {
  background-color: #e9ecef;
  color: #495057;
}

.form-control:disabled,
.form-control[readonly] {
  -webkit-appearance: none;
  appearance: none;
}

#bestellingModal textarea {
  height: 100px;
}

#agenda .col {
  padding: 5px;
}

.o-item {
  font-size: 14px;
}

#agenda .week {
  height: auto;
}

#agenda {
  margin-top: 0 !important;
}

.filterChauffeur:hover,
.filterChauffeur label:hover,
.filterChauffeur input:hover {
  cursor: pointer;
}

.filterChauffeur label {
  font-size: 15px;
  position: relative;
  z-index: 10;
  margin: 0;
}

.filterChauffeur {
  position: relative;

  margin: 0 0 0 5px !important;
}

.filterChauffeur label {
  background-color: #f8f9fa;
  border: 1px solid rgba(0, 0, 0, 0.125);
  width: 100%;
  height: 100%;
  display: block;
  padding: 6px 12px;
  top: 0;
  left: 0;
  border-radius: 4px;
}

.filterChauffeur input[type="checkbox"]:checked + .control-me {
  background-color: red;
}

.filterChauffeur input[type="checkbox"]:checked + label {
  background-color: slategrey;
  color: white;
}

.filterChauffeur input[type="checkbox"] {
  position: absolute;
  left: -100vw;
}
.signatureContainer {
  height: 180px;
  width: 100%;
  border: 3px dashed #ccc;
}

.vuecal__event {
  cursor: pointer;
}

.vuecal__event-title {
  font-size: 0.8em;
  letter-spacing: -0.5px;
  font-weight: bold;
  margin: 4px 0 -6px 0;
  padding-bottom: 0px;
}

.vuecal__event-time {
  display: inline-block;
  font-size: 0.8em;
  margin-bottom: -16px;
}

.vuecal__event-content {
  font-style: italic;
  font-size: 0.8em;
  margin-top: -4px;
}

.ophaling {
  background-color: #ffc10742;
}

.levering-product {
  background-color: #007bff42;
}

.levering {
  background-color: #28a7455c;
}

.vuecal {
  height: 90vh;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
}

.vuecal__event {
  cursor: pointer;
  text-align: left;
  padding: 10px;
}

.vuecal__event-time span {
  display: none;
}

.unplanned {
  display: flex;
}

.unplanned-item:hover {
  cursor: move;
}

.unplanned-item {
  width: 250px;
  margin: 5px;
  margin-bottom: 5px;
  padding: 10px 20px;
}

.unplanned-item strong,
.unplanned-item div {
  font-size: 14px;
}

.unplannedContainer {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
}

.btn-cmr {
  margin-right: 20px;
}
</style>
